import { VipIcon } from '@/app/components/icons/VipIcon';

import { Label } from '@/app/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/app/components/ui/radio-group';
import { cn } from '@/app/utils';

interface RadioOption {
  label: string;
  value: string;
  showVipIcon?: boolean;
}

interface CardRadioGroupProps {
  value?: string;
  onSelect?: (value: string) => void;
  options: RadioOption[];
  align?: 'left' | 'center';
}

export const CardRadioGroup = ({ value, onSelect, options, align = 'center' }: CardRadioGroupProps) => {
  return (
    <RadioGroup className="group flex w-full flex-2 flex-wrap gap-2" value={value} onValueChange={onSelect}>
      {options.map(({ label, value, showVipIcon }) => {
        return (
          <div className="relative flex-1" key={value}>
            <RadioGroupItem value={value} id={value} className="peer hidden" />
            <Label
              htmlFor={value}
              className={cn(
                'flex h-10 cursor-pointer select-none flex-wrap items-center gap-1 rounded-8 border border-transparent bg-system-white04 p-2 text-sm text-system-white48 group-aria-disabled:cursor-not-allowed peer-aria-[checked=true]:border-system-white peer-aria-[checked=true]:text-system-white',
                align === 'left' && 'justify-start',
                align === 'center' && 'justify-center',
              )}
            >
              {label}
              {showVipIcon && <VipIcon className="text-base" />}
            </Label>
          </div>
        );
      })}
    </RadioGroup>
  );
};
